<template>
  <section class="home-traveling">
    <b-container class="h-100">
      <b-row class="h-100">
        <b-col sm="12" md="6" lg="6">
         <div class="home-traveling-text">
           <div class="home-traveling-content-img">
             <img class="main-photo" src="../../assets/img/users-info/world-img.svg" alt="World image">
           </div>
           <div class="home-traveling-content-text">
             <h4 class="title">{{$t('home_traveling_title')}}</h4>
             <p class="subtitle">{{$t('home_traveling_subtitle')}}</p>
           </div>
         </div>
        </b-col>
        <b-col sm="12" md="6" lg="6">
          <div class="country-img">
            <div class="top-img">
              <img class="flag ukr" src="../../assets/img/users-info/fаlag-ukr.svg" alt="Country Flag">
              <img class="flag it" src="../../assets/img/users-info/fаlag-it.svg" alt="Country Flag">
            </div>
            <div class="bottom-img">
              <img class="flag de" src="../../assets/img/users-info/fаlag-ger.svg" alt="Country Flag">
              <img class="flag es" src="../../assets/img/users-info/fаlag-sp.svg" alt="Country Flag">
              <img class="flag pl" src="../../assets/img/users-info/fаlag-pl.svg" alt="Country Flag">
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/sass/app";
.home-traveling{
  padding: 38px 0;
  transition: transform 0.3s ease;
  .country-img{
    .ukr{
      transform: rotate(0deg);
    }
    .it{
      transform: rotate(-15deg);
    }
    .de{
      transform: rotate(10deg);
    }
    .es{
      transform: rotate(-5deg);
    }
    .pl{
      transform: rotate(10deg);
    }
  }
  &:hover{
    .country-img{
      .ukr{
        transform: rotate(10deg);
      }
      .it{
        transform: rotate(-30deg);
      }
      .de{
        transform: rotate(-10deg);
      }
      .es{
        transform: rotate(15deg);
      }
      .pl{
        transform: rotate(-10deg);
      }
    }
  }
  .home-traveling-text {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    gap: 32px;
    @media screen and (min-width: 320px) {
      flex-direction: column;
    }
    @media screen and (min-width: 992px) {
      flex-direction: row;
    }
    .home-traveling-content-text {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
      font-family: $main-font;
      color: #30394B;
      gap: 16px;
      .title{
        font-size: 24px;
        font-weight: 700;
        line-height: 28.8px;
        text-align: left;
        margin: 0;
        @media screen and (min-width: 320px) {
          font-size: 20px;
          line-height: 120%;
        }
        @media screen and (min-width: 992px) {
          font-size: 24px;
          line-height: 28.8px;
        }
      }
      .subtitle{
        font-size: 18px;
        font-weight: 300;
        line-height: 25.2px;
        text-align: left;
        margin: 0;
        @media screen and (min-width: 320px) {
          font-size: 16px;
          line-height: 140%;
        }
        @media screen and (min-width: 992px) {
          font-size: 18px;
          line-height: 25.2px;
        }
      }
    }
  }
  .country-img {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    @media screen and (min-width: 320px) {
      height: 100%;
    }
    img{
      width: 62px;
      height: 62px;
      transform-origin: center;
      transition: transform 0.3s ease;
      border-radius: 16px;
      box-shadow: 0 6px 16px -2px rgba(204,204,204,1);
      @media screen and (min-width: 320px) {
        width: 30px;
        height: 30px;
      }
      @media screen and (min-width: 768px) {
        width: 62px;
        height: 62px;
      }
    }
    .ukr{
      position: relative;
      top: 10px;
      left: 30px;
      @media screen and (min-width: 320px) {
        top: 10px;
        left: 30px;
      }
    }
    .it{
      position: relative;
      top: -20px;
      right: 30px;
      @media screen and (min-width: 320px) {
        top: 10px;
      }
    }
    .top-img,
    .bottom-img{
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 100%;
    }
  }
}
</style>
